import { useLanguage } from "@/i18n/LanguageContext";
import StoryCard from "./StoryCard";

interface StoryFeedProps {
  stories: {
    id: number;
    name: string;
    neighborhood: string;
    service: string;
    date: string;
    hasPhotos: boolean;
    title: string;
    bodyEn: string;
    bodyEs: string;
  }[];
  sortBy: string;
  setSortBy: (v: string) => void;
  onOpenMobileFilters: () => void;
}

export default function StoryFeed({ stories, sortBy, setSortBy, onOpenMobileFilters }: StoryFeedProps) {
  const { t, currentLang } = useLanguage();

  const sortOptions = [
    { value: "Most Recent", key: "reviews.sortRecent" },
    { value: "With Photos", key: "reviews.sortPhotos" },
  ];

  return (
    <div>
      {/* Toolbar */}
      <div className="flex items-center justify-between gap-3 mb-6">
        <div className="flex items-center gap-3">
          <button
            onClick={onOpenMobileFilters}
            className="lg:hidden flex items-center gap-2 px-3 py-2 bg-white border border-stone-200 rounded-lg text-sm font-medium text-secondary cursor-pointer"
          >
            <i className="ri-filter-3-line" />
            {t("reviews.filterTitle")}
          </button>
          <span className="text-sm text-stone-500">
            {stories.length} {t("reviews.showingCount")}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <label className="text-sm text-stone-500 hidden sm:block">{t("reviews.sortLabel")}</label>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="text-sm border border-stone-200 rounded-lg px-3 py-2 text-secondary bg-white focus:outline-none focus:ring-2 focus:ring-primary/20 cursor-pointer"
          >
            {sortOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {t(opt.key)}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Cards */}
      <div>
        {stories.map((story) => (
          <StoryCard key={story.id} story={story} />
        ))}
      </div>
    </div>
  );
}